import apiUrl from "../../../../../utils/settings";

export const sendOtpUrl = () => {
  return apiUrl + '/auth/v2/otp/send';
};
export const verifyOtpUrl = () => {
  return apiUrl + '/auth/v2/otp/verify';
};
export const createEPinUrl = () => {
  return apiUrl + '/auth/v2/epin';
};
export const registerUrl = () => {
  return apiUrl + '/auth/v2/register';
};




